import querystring from 'querystring';
import axios from 'axios';

export const followTypes = {
  ad: 'ad',
  account: 'account',
  user: 'user',
  advertiser: 'advertiser',
  campaign: 'campaign',
  content: 'content',
  contentStream: 'contentStream',
  contentStreamEvent: 'contentStreamEvent',
  lineItem: 'lineItem',
  supplyRoute: 'supplyRoute',
};

export const getUserFollows = async ({ followType, nestingParams }) => {
  let q = '';
  if (Object.keys(nestingParams).length) {
    // eslint-disable-next-line no-param-reassign
    Object.keys(nestingParams).forEach((key) => nestingParams[key] === undefined && delete nestingParams[key]);
    const params = querystring.stringify(nestingParams);
    q = `?${params}`;
  }
  const url = `${SERVICE_URL}/api/v1/user-follows/${followType}${q}`;
  return axios.get(url).then((response) => response.data);
};

export const createUserFollow = async ({ accountId, followId, followType }) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/user-follows`;
  return axios
    .put(url, {
      followId,
      followType,
    })
    .then((response) => response.data);
};

export const deleteUserFollow = async ({ accountId, followId, followType }) => {
  const url = `${SERVICE_URL}/api/v1/account/${accountId}/user-follows`;
  return axios
    .delete(url, {
      data: {
        followId,
        followType,
      },
    })
    .then((response) => response.data);
};
